module.exports = __webpack_public_path__ + "static/media/smoke.bb22a98f.svg";